export interface ImbalanceItem {
    material: string;
    size: string;
    quality: string;
    coo: string;
    wmsQty: number;
    ciBondedQty: number;
    ciNonBondedQty: number;
    ciTotalQty: number;
    imbalance: number;
    persistentImbalance: number;
    direction: string;
    cleanStatus: string;
    flowInformation: string;
}

export type DirectionFilter = 'all' | 'zero' | 'over' | 'under';

export type StatusFilter = 'all' | 'open' | 'submitted';

export type MonthOption = {
    label: string;
    value: string;
    threshold: number;
};

type ActionedStatus = 'processing' | 'processed';

export type ActionedRecord = {
    status: ActionedStatus;
    adjType: string;
    units: number;
    lc: string;
    bucket: string;
    ref?: string;
    ts?: string;
};

type BatchError = {
    batchIndex: number;
    itemRange: [number, number];
    error: string;
};

export type BatchProgress = {
    completedItems: number;
    totalItems: number;
    failedItems: number;
    percentage: number;
    errors: BatchError[];
    done: boolean;
};

export type BucketData = {
    zero: ImbalanceItem[];
    under: ImbalanceItem[];
    over: ImbalanceItem[];
};

export type BucketFilters = {
    zero: string;
    under: string;
    over: string;
};

export type BucketConfig = {
    key: 'zero' | 'over' | 'under';
    name: string;
    actionLabel: string;
    adjBadgeClass: string;
    adjBadgeText: string;
    lcBadgeClass: string;
    lcBadgeText: string;
    lcDotColor: string;
    btnLabel: string;
    unitLabel: string;
};

export const BUCKET_CONFIGS: BucketConfig[] = [
    {
        key: 'zero',
        name: 'WMS = 0',
        actionLabel: 'Cleanup',
        adjBadgeClass: 'b-negadj',
        adjBadgeText: 'NEGADJ',
        lcBadgeClass: 'b-lc-yes',
        lcBadgeText: 'LC: Yes',
        lcDotColor: 'var(--pds-color-text-success)',
        btnLabel: 'Perform cleanup',
        unitLabel: 'units total to clean'
    },
    {
        key: 'over',
        name: 'WMS > CI',
        actionLabel: 'Cleanup',
        adjBadgeClass: 'b-posadj',
        adjBadgeText: 'POSADJ',
        lcBadgeClass: 'b-bonded',
        lcBadgeText: 'Bonded',
        lcDotColor: '',
        btnLabel: 'Perform cleanup',
        unitLabel: 'units total to clean'
    },
    {
        key: 'under',
        name: 'WMS < CI',
        actionLabel: 'Adjust All',
        adjBadgeClass: 'b-negadj',
        adjBadgeText: 'NEGADJ',
        lcBadgeClass: 'b-lc-no',
        lcBadgeText: 'LC: No',
        lcDotColor: 'var(--pds-color-text-critical)',
        btnLabel: 'Perform adjust all',
        unitLabel: 'units total to adjust all'
    },
];
